import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { Status } from "src/app/models/statusEnums";
import { TasksService } from "src/app/profile/tasks";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { TaskStatus, TaskCategory } from "../../model/models";
import { saveAs } from "file-saver";
import { LocalDatePipe } from '../../../shared/pipes/local-date.pipe';
import * as _ from "lodash";
import { CdTimerComponent } from 'angular-cd-timer';
import { OverlayPanel } from "primeng/overlaypanel";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormErrorHandler } from "../../helpers/form-error-handler.helper";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TaskType } from "../../enums/task.enum";
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from "../../constants/modules.constant";
import { AccountOpportunityService } from "src/app/accounts-v2/services/account-opportunity.service";
import { ReAssignTaskPayload } from "../../models/create-task/reAssign.model";
import { TaskCommentTimelines, TaskDetailsM, TaskDetailsResponseM } from "../../models/task/task-details.model";
import { ParseHelper } from "../../parse.helper";
import { SharedTaskService } from "src/app/shared/shared-task/shared-task.service";
import { ComponentCommunicationService } from "../../services/component-communication.service";

@Component({
    selector: "app-details-task",
    templateUrl: "./details-task.component.html",
    styleUrls: ["./details-task.component.scss"],
    providers: [LocalDatePipe]
})

export class DetailsTaskComponent implements OnInit, OnChanges, OnDestroy {

    //track time
    @ViewChild('basicTimer') basicTimer: CdTimerComponent;
    @ViewChild('timers') timers: OverlayPanel;

    @Input() headerTitle: string;
    @Input() display: boolean = false;
    @Input() selectedTaskId: number;
    @Input() isViewMode = false;

    @Output() cancelClicked = new EventEmitter();
    @Output() onUpdateComplete = new EventEmitter();

    //new property for View task details & add comment
    taskSharedWith: any;
    taskStages: any;
    totalTaskTimeSpent: any;
    addCommentForm: FormGroup = new FormGroup({});
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    displayAddEditDialog: boolean = false;
    commentTaskId: number;
    stopTimerId: any
    timeDate: any;
    TaskType = TaskType;
    selectedReAssignData:any = null;

    timeSpent: any[] = [];
    isMini = false;
    stopTime: Date;

    currentHeaderTitle;
    currentDisplay: boolean = false;
    allTaskStatus: TaskStatus[] = [];
    taskStatuses: TaskStatus[] = [];
    taskCategories: TaskCategory[] = [];
    showStatusValidation: boolean = false;
    showValidation: boolean = false;
    assignUsersDD = [];
    activeUsers = [];
    minimumDate = null;
    selectedUsers;
    startDateTime = null;
    endDateTime = null;
    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv'];
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
        <li>Files with extensions: doc, docx, pdf, xls, xlsx, txt, gif, jpeg are allowed</li>
    </ul>
    `;
    mimeTypes = [
        { extension: "csv", value: "text/csv;charset=utf-8" },
        { extension: "doc", value: "application/msword;charset=utf-8" },
        { extension: "docx", value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" },
        { extension: "gif", value: "image/gif;charset=utf-8" },
        { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
        { extension: "jpg", value: "image/jpeg;charset=utf-8" },
        { extension: "png", value: "image/png;charset=utf-8" },
        { extension: "pdf", value: "application/pdf;charset=utf-8" },
        { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
        { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
        { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
        { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
        { extension: "zip", value: "application/zip;charset=utf-8" },
        { extension: "txt", value: "text/plain;charset=utf-8" }
    ];

    taskData: TaskDetailsResponseM = null;
    task: TaskDetailsM = null;
    taskStatusAttachments: any[] = [];

    checkList = [];
    displayComment = false;
    appComponent: any;

    //associationClickable
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    displayLeadViewEdit: boolean = false;
    selectedLeadId: number = 0;
    displayOpportunityViewEdit: boolean = false;
    opportunityEditViewId: number = 0;
    defaultPanelData:number=20;
    displayCaseViewEdit: boolean = false;
    caseEditViewId: number = 0;
    groupUserList:any[] = [];

    taskActionOptions = [
        {id:1, code: 're-assign', name:"Re-assign"},
        {id:2, code: 'sub-task', name:"Sub Task"},
        {id:3, code: 'comment', name:"Comment",},
    ];

    selectedTaskOption: any = null;
    displayReassign = false;
    reassignUsers = [];
    selectedReassignUser;
    displayUsers = false;

    //Sub Task
    displaySubTask: boolean = false;
    editedSubtaskDetails: any = null;
    selectedTaskDataForSubTask:any;
    notificatonEmailCheckbox: boolean = false;

    //#ReactiveForm
    reAssignUserForm: FormGroup = new FormGroup({});

    constructor(
        private messageService: MessageService,
        private taskService: TasksService,
        private appMainService: AppMainService,
        public app: AppMainComponent,
        public localDatePipe: LocalDatePipe,
        private formBuilder: FormBuilder,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private accOpportunityService: AccountOpportunityService,
        private sharedTaskService: SharedTaskService,
        private componentCommunicationService: ComponentCommunicationService
    ) { }

    ngOnInit(): void {
        this.appComponent = this.app;
        this.checkIdleTime();
        this.startCounter();
        if (this.selectedTaskId) {
            this.fetchSelectedTask(this.selectedTaskId);
        }
        this.initTaskAddCommentForm();
        this.initReAssignUserForm();
        this.fetchTaskStatuses();
        this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.selectedTaskId?.previousValue && changes?.selectedTaskId?.currentValue) {
            this.selectedTaskId = changes?.selectedTaskId?.currentValue;
            this.fetchSelectedTask(this.selectedTaskId);
        }

        if (changes?.headerTitle?.currentValue) {
            this.currentHeaderTitle = changes.headerTitle.currentValue;
        }

        if (changes?.display?.currentValue) {
            this.currentDisplay = changes.display.currentValue;
        }

        if (changes?.isViewMode?.currentValue) {
            this.isViewMode = changes.isViewMode.currentValue;
        }
    }

    fetchTaskStatuses() {
        this.appMainService.isShowSpinner("fetchTaskStatuses");
        this.taskService
            .getTaskStatuses()
            .then((taskStatuses: TaskStatus[]) => {
                this.appMainService.isHideSpinner("fetchTaskStatuses");
                this.allTaskStatus = taskStatuses;
            }).catch(() => {
                this.appMainService.isHideSpinner("fetchTaskStatuses");
            });
    }

    fetchSelectedTask(taskId) {
        this.appMainService.isShowSpinner("getSelectedTask");
        this.taskService.getTaskDetailForView(taskId).subscribe({
            next: (response) => {

                if (this.isMini) {
                    this.onMaximize();
                }

                this.taskData = response;
                this.task = response?.task ? _.cloneDeep(response.task) : null;
                
                //Extra Info Same As Child Task
                this.task.reAssignedTo = this.taskData?.reAssignedTo||null;
                this.task.reAssignedDate = this.taskData?.reAssignedDate||"";
                this.task.reAssignedStatus = this.taskData?.reAssignedStatus||null;
                this.task.reAssignedToName = this.taskData?.reAssignedToName||"";
                this.task.taskUsersName = this.taskData?.assignedToName||"";
                this.task.taskUsers = this.taskData?.assignedTo;
                this.setInitialCheckboxState();

                if (!this.task) {
                    this.appMainService.isHideSpinner("getSelectedTask");
                    this.messageService.add({ severity: 'error', summary: 'Task details not found ...' });
                    return;
                }

                if (this.task.sharedTaskUsers && this.task.sharedTaskUsers?.length > 0) {
                    const userNames = this.task.sharedTaskUsers.map(user => user.name.trim());
                    this.taskSharedWith = userNames.join(', ');
                }

                if (this.taskData?.taskStages && this.taskData?.taskStages?.length > 0) {
                    const userNames = this.taskData?.taskStages.map(stage => stage.stageName?.trim());
                    this.taskStages = userNames.join(', ');
                }

                this.checkList = this.task.taskCheckLists?.map((obj) => {
                    return {
                        id: obj?.id,
                        description: obj?.description,
                        isCheck: obj?.isCheck,
                        statusId: obj?.statusId
                    }
                });

                if ([TaskType.Individual,TaskType.Subtask].includes(this.task?.taskTypeId) && this.task?.taskTimerDto && this.task.taskTimerDto?.isTimerStarted) {
                    this.task['timerResponse'] = this.task.taskTimerDto;
                    this.task['taskStartTime'] = new Date(this.task.taskTimerDto.startTime);
                    if (this.task.taskTimerDto?.isTimerStarted) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Success',
                            detail: this.task.taskTimerDto.message
                        })
                        this.checkTimerRunningTasks();
                    }
                }

                if (this.task.childTaskDto && this.task.childTaskDto?.length > 0) {
                    this.task.childTaskDto.forEach(childTask => {
                        if (childTask.taskTimerDto && childTask.taskTimerDto.isTimerStarted) {
                            childTask['timerResponse'] = childTask.taskTimerDto;
                            childTask['taskStartTime'] = new Date(childTask.taskTimerDto.startTime);
                            if (childTask?.taskTimerDto?.isTimerStarted) {
                                this.messageService.add({
                                    severity: 'success',
                                    summary: 'Success',
                                    detail: childTask.taskTimerDto.message
                                });

                            }
                        }

                        //check timer for childSubTasks in group task
                        if (childTask?.childSubTasks && childTask?.childSubTasks?.length > 0) {
                            childTask.childSubTasks.forEach(subTask => {
                                if (subTask?.taskTimerDto && subTask.taskTimerDto?.isTimerStarted) {
                                    subTask['timerResponse'] = subTask.taskTimerDto;
                                    subTask['taskStartTime'] = new Date(subTask.taskTimerDto.startTime);
                                    if (subTask?.taskTimerDto?.isTimerStarted) {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Success',
                                            detail: subTask.taskTimerDto.message
                                        });
                                    }
                                }
                            });
                        }
                    });

                    this.checkTimerRunningTasks();
                }

                this.task.taskStatuses = this.task.taskStatuses.sort((a, b) => (new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()));
              
                if ([TaskType.Individual,TaskType.Subtask].includes(this.task?.taskTypeId)) {
                    this.task.commentTimelines = this.generateTaskHistory(this.task,this.task.taskStatuses);
                }

                if(this.task?.childTaskDto?.length > 0){
                    this.task.childTaskDto.map(groupTaskData => {
                        groupTaskData.commentTimelines = this.generateTaskHistory(groupTaskData,groupTaskData.taskStatuses);
                    });
                    
                }

                if (this.task.childTaskDto && this.task.childTaskDto.some(task => task.childSubTasks && task.childSubTasks.length > 0)) {
                    this.task.childTaskDto.forEach(groupTaskData => {
                        if (groupTaskData.childSubTasks && groupTaskData.childSubTasks.length > 0) {
                            groupTaskData.childSubTasks = groupTaskData.childSubTasks.map(subTask => {
                                subTask.commentTimelines = this.generateTaskHistory(subTask, subTask.taskStatuses);
                                return subTask;
                            });
                        }
                    });
                  }
 
                  this.task?.commentTimelines?.map(item => {
                    return item.visibleCount=this.defaultPanelData
                 });

                this.task?.childTaskDto?.forEach(item => {
                    item.commentTimelines?.map(comment => {
                       return comment.visibleCount=this.defaultPanelData
                    })
                 });

                this.appMainService.isHideSpinner("getSelectedTask");
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getSelectedTask');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To Fetch Task Details'
                });
            }
        })
    }

    generateTaskHistory(taskDetails: any, statusList: TaskCommentTimelines[]){
        const statusHistory: TaskCommentTimelines[] = [];
        let allStatus = ParseHelper.DeepCopy(statusList);
        allStatus = allStatus.reverse();

        let taskCurrentAssignee: string = taskDetails.taskUsersName;
        let groupIndex = 0;

        allStatus.map((statusDetails, i)=>{
            statusDetails = this.formatTaskStatus(statusDetails);
            if(['Create','Update','ReAssign'].includes(statusDetails.actionType)){
                groupIndex = statusHistory.length;
                if(statusDetails.actionType=='ReAssign'){
                    taskCurrentAssignee = statusDetails.reAssignedUserName;
                }
                statusHistory.push({
                    ...statusDetails,
                    groupUserName: ParseHelper.DeepCopy(taskCurrentAssignee),
                    commentList: [statusDetails]
                });
            }else{
                statusHistory[groupIndex].commentList.push(statusDetails);
            }
        });

        statusHistory.reverse().map(group=>{
            group.commentList =  group.commentList.reverse();
        });

        return statusHistory;
    }

    formatTaskStatus(statusDetails: TaskCommentTimelines){
        statusDetails.colorClass = 'bg-note';
        statusDetails.icon = 'pi pi-ticket';
        switch(statusDetails.actionType){
            case 'Create':
                statusDetails.statusHeader = `Task Created by ${statusDetails.createdByName}`;
                statusDetails.colorClass = 'bg-event';
                statusDetails.icon = 'pi pi-ticket';
                break;
            case 'ReAssign':
                statusDetails.statusHeader = `Task Re-Assigned to ${statusDetails.reAssignedUserName} by ${statusDetails.createdByName}`;
                statusDetails.colorClass = 'bg-event';
                statusDetails.icon = 'pi pi-directions';
                break;
            case 'Update':
                statusDetails.statusHeader = `Task Status Updated to ${statusDetails.status.name} by ${statusDetails.createdByName}`;
                break;
            case 'View':
                statusDetails.statusHeader = `Task Viewed by ${statusDetails.createdByName}`;
                statusDetails.colorClass = 'bg-viewIcon';
                statusDetails.icon = 'pi pi-eye';
                break;
                
            case 'Edit':
                statusDetails.statusHeader = `Task Edited by ${statusDetails.createdByName}`;
                statusDetails.colorClass = 'bg-editIcon';
                statusDetails.icon = 'pi pi-pencil';
                break;
            case 'Reminder':
                statusDetails.statusHeader = `Task Reminder Sent by ${statusDetails.createdByName} to ${statusDetails.reAssignedUserName}`;
                statusDetails.colorClass = 'bg-remiderIcon';
                statusDetails.icon = 'pi pi-bell';
                break;
            default:
                statusDetails.statusHeader = `Comment Added by ${statusDetails.createdByName}`;
                statusDetails.colorClass = 'bg-note';
                statusDetails.icon = 'pi pi-comment';
                break;
        }

        return statusDetails;
    }


    onCustomUpload(files: File[]) {
        this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
            for (let file of files) {
                if (file.size > 2 * 1024 * 1024) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: file.name + ":File size exceeds the 2MB limit.Please upload a smaller file."
                    });
                    this.appMainService.isHideSpinner('upload');
                } else {
                    let errors = validateFiles(file, 25, this.allowedExtensions);

                    if (errors.length > 0) {
                        for (let error of errors) {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error.fileName + ": " + error.error
                            });
                        }

                        this.appMainService.isHideSpinner('upload');
                    } else {
                        uploadFiles(file, ({ name, content, size, extension }) => {
                            let attachment = {
                                id: 0,
                                createdSource: this.app.userIP,
                                updatedSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                updatedBy: 0,
                                createdDate: new Date().toDateString(),
                                updatedDate: new Date().toDateString(),
                                name: name,
                                guidName: "string",
                                location: "string",
                                content: content,
                                extension: extension,
                                mediaType: "string",
                                sizeInBytes: size,
                                description: "string",
                                statusId: Status.Active,
                                isValid: true,
                                validFromDate: null,
                                validToDate: null,
                            };

                            let attachmentData = {
                                id: 0,
                                createdSource: this.app.userIP,
                                updatedSource: this.app.userIP,
                                createdBy: this.app.user.userId,
                                updatedBy: null,
                                createdDate: new Date().toDateString(),
                                updatedDate: new Date().toDateString(),
                                taskStatusId: this.selectedTaskId,
                                attachmentId: 0,
                                attachment: attachment,
                            };
                            this.attachments.push(this.formBuilder.group(attachmentData));
                            this.taskStatusAttachments.push(
                                this.app.copyObjectWithoutRefrence(attachmentData)
                            );
                            this.appMainService.isHideSpinner('upload');
                        });
                    }
                }
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }

    }

    removeAttachment(index) {
        this.taskStatusAttachments.splice(index, 1);
    }

    downloadFile(name: string, content: string, locationUrl: string) {
        let ext = name.substring(name.lastIndexOf('.') + 1);
        ext = ext ? ext.toLocaleLowerCase() : '';

        let mime_type = this.mimeTypes.filter(el => el.extension === ext);
        if (mime_type.length > 0 && content) {
            const base64 = content;
            const mime = mime_type[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else {
            window.open(locationUrl);
        }
    }

    dataURItoBlob(dataURI: string, mimeType: string) {
        const kept = dataURI.split(",", 2);
        const byteString = atob(kept[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: mimeType });
        return blob;
    }


    closeTaskEdit() {
        this.displayAddEditDialog = false;
    }

    loadNewList() {
        this.fetchSelectedTask(this.selectedTaskId);
        this.onUpdateComplete.emit({});
    }

    cancelTask() {
        if (this.timerRunningTasks?.length > 0) {
            this.confirmationService.confirm({
                message: "The timer is currently running. Are you sure you want to close this task?",
                header: "Change Confirmation",
                icon: "pi pi-info-circle",
                key: 'confirm-task',
                accept: () => {
                    this.stopAllRuningTasks();
                    this.onBodyAuto();
                    this.currentDisplay = false;
                    this.cancelClicked.emit({});
                },
                reject: () => { },
            });
        }
        else {
            this.currentDisplay = false;
            this.cancelClicked.emit({});
            this.onBodyAuto();
        }
    }

    //#region Task Timer

    checkIdleTime() {
        let confirmationDialogOpen: boolean = false;
        let confirmationTimeout: any;
        this.app.idle.onTimeoutWarning.subscribe(seconds => {
            const idleSeconds = this.app.timeouttime - seconds;
            if (idleSeconds >= (600) && this.timerRunningTasks?.length > 0 && !confirmationDialogOpen) {
                confirmationDialogOpen = true;
                this.confirmationService.confirm({
                    message: "The timer is currently running. Are you still working on this task?",
                    header: `Timer Running!
                    Task ID:${this.timerRunningTasks[0].taskId}.`,
                    icon: "pi pi-info-circle",
                    accept: () => {
                        clearTimeout(confirmationTimeout);
                        confirmationDialogOpen = false;
                    },
                    reject: () => {
                        clearTimeout(confirmationTimeout);
                        this.handleTaskConfirmationPopUp();
                        confirmationDialogOpen = false;
                    },
                });
                confirmationTimeout = setTimeout(() => {
                    this.handleTaskConfirmationPopUp();
                    confirmationDialogOpen = false;
                }, 30000);
            }
        });
    }

    handleTaskConfirmationPopUp() {
        this.stopAllRuningTasks();
        this.onBodyAuto();
        this.currentDisplay = false;
        this.cancelClicked.emit({});
    }

    get timerRunningTasks() {
        let taskList: any[] = [];
        if ([TaskType.Individual,TaskType.Subtask].includes(this.task?.taskTypeId) && this.task?.taskStartTime) {
            taskList = [this.task];
        }

        const childTasks = this.task?.childTaskDto?.length > 0 ? this.task?.childTaskDto.filter(task => task?.taskStartTime) : []
        taskList = [...taskList,...childTasks];

        return taskList; 
    }

    startCounter() {
        this.stopTime = new Date()
        setTimeout(() => {
            this.startCounter()
        }, 1000)
    }

    startTaskTimer(taskDetails: any) {
        this.appMainService.isShowSpinner("getTaskTimer");
        this.taskService.startTaskTimer(taskDetails?.taskId).subscribe({
            next: (response) => {
                taskDetails['timerResponse'] = response;
                taskDetails['taskStartTime'] = new Date(response?.startTime);
                if (taskDetails.timerResponse?.isTimerStarted) {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: taskDetails.timerResponse.message
                    })
                }
                this.checkTimerRunningTasks();

                this.appMainService.isHideSpinner("getTaskTimer");
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getTaskTimer');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To  Start Task Timer'
                });
            }
        })
    }

    stopAllRuningTasks() {
        if (this.timerRunningTasks?.length > 0) {
            this.timerRunningTasks.map(taskDetails => {
                this.stopTaskTimer(taskDetails);
            })
        }
    }

    stopTaskTimer(taskDetails: any) {
        if (taskDetails?.timerResponse?.id) {
            this.appMainService.isShowSpinner("getTaskTimer");
            this.taskService.stopTaskTimer(taskDetails?.timerResponse?.id).subscribe({
                next: (response) => {
                    taskDetails['taskStartTime'] = null;
                    taskDetails['timerResponse'] = null;
                    this.getTaskTimer(taskDetails);
                    this.taskService.clearTimerRunningTaskData();
                    this.appMainService.isHideSpinner("getTaskTimer");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getTaskTimer');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Failed To Stop Task Timer'

                    });
                }
            })
        }
    }

    getTimeTracked(taskDetails: any) {
        const startTime = taskDetails?.taskStartTime ? new Date(taskDetails?.taskStartTime).getTime() : 0;
        const endTime = new Date(this.stopTime || new Date()).getTime();
        return (taskDetails?.taskStartTime && this.stopTime && endTime > startTime) ? +this.stopTime - +taskDetails?.taskStartTime : 0;
    }

    //#endregion Task Timer

    addComment(selectedTaskData: any) {
        let taskStatus: any = selectedTaskData?.taskStatuses?.[0].statusId;
        let currentUserId = selectedTaskData?.reAssignedTo||selectedTaskData?.taskUsers;
        let activeUser: any = this.activeUsers.find(user => user?.id === currentUserId);
        this.commentTaskId = selectedTaskData?.taskId;

        if([selectedTaskData.createdBy, currentUserId].includes(this.app.userId)){
            this.addCommentForm.get('status').enable();
        }else{
            this.addCommentForm.get('status').disable();
        }

        this.addCommentForm.patchValue({
            assignTo: activeUser?.name,
            status: taskStatus
        });

        this.displayComment = true;
    }

    //#region Timer
    getTaskTimer(taskDetails: any) {
        this.appMainService.isShowSpinner("getTaskTimer");
        this.taskService.getTaskTimerForView(taskDetails?.taskId).subscribe({
            next: (response) => {
                taskDetails['totalTaskTimeSpent'] = response?.totalTaskTimeSpent || "";
                this.appMainService.isHideSpinner("getTaskTimer");
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getTaskTimer');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To Get Timer Details'
                });
            }
        })
    }

    fetchTimerHistory(event: Event, taskDetails: any) {
        this.appMainService.isShowSpinner("getTaskTimerHistory");
        this.taskService.getTaskTimerHistroyForView(taskDetails?.taskId).subscribe({
            next: (response: any) => {
                this.timeSpent = response;
                this.timers.toggle(event);
                this.appMainService.isHideSpinner("getTaskTimerHistory");
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getTaskTimerHistory');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To Get Timer History'
                });
            }
        })
    }

    //#region Add Comment
    initTaskAddCommentForm() {
        this.detailsFormErrors = {};
        this.addCommentForm = this.formBuilder.group({
            id: [0],
            assignTo: [null],
            attachmentLinks: this.formBuilder.array([]),
            status: ['', Validators.required],
            comments: [null]
        });

        this.formErrorHandler.handleErrors(this.addCommentForm, this.detailsFormErrors, {
            startDateTime: {
                status: 'Status is required'
            }
        });

    }

    get attachments(): FormArray {
        return <FormArray>this.addCommentForm.controls.attachmentLinks;
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);
        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }
    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    downloadFileI(name: string, content: string, locationUrl: string) {
        let ext = name.substring(name.lastIndexOf('.') + 1);

        let mime_type = this.mimeTypes.filter(el => el.extension === ext);
        if (mime_type.length > 0 && content) {
            const base64 = content;
            const mime = mime_type[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else {
            window.open(locationUrl);
        }
    }

    saveComment() {
        const addCommentForm = this.addCommentForm.getRawValue();
        if (this.addCommentForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const taskStatus = {
            id: 0,
            createdSource: this.app.userIP,
            updatedSource: null,
            createdBy: this.app.user.userId,
            updatedBy: null,
            createdDate: new Date(),
            updatedDate: null,
            taskId: this.commentTaskId,
            statusId: addCommentForm.status,
            status: null,
            description: addCommentForm.comments,
            taskStatusAttachments: this.taskStatusAttachments,
            createdByName: null,
        }

        this.appMainService.isShowSpinner("changeTaskStatus");
        this.taskService
            .changeTaskStatus(taskStatus)
            .then(() => {
                this.appMainService.isHideSpinner("changeTaskStatus");
                this.addCommentForm.reset();
                this.taskStatusAttachments = [];
                this.loadNewList();
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Task status changed successfully...",
                });
                this.displayComment = false;
            })
            .catch(() => {
                this.appMainService.isHideSpinner("changeTaskStatus");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Please fill out the required information...",
                });
            });
    }

    cancelComment() {
        this.displayComment = false;
        this.addCommentForm.reset();
        this.taskStatusAttachments = [];
    }

    deleteTask() {
        if (!this.taskData.isEditable) {
            this.messageService.add({
                severity: 'info',
                summary: ' Status Info',
                detail: this.taskData.isEditableMsg
            });
            return;
        }
        if(this.taskData.task.taskTypeId==TaskType.Subtask){
            const returnFromdeleteTask = true;
            return this.deleteSubTask(this.taskData?.task, returnFromdeleteTask);
        }
        else {
            this.confirmationService.confirm({
                message: "Do you want to Delete this Task?",
                header: "Change Confirmation",
                icon: "pi pi-info-circle",
                key: 'confirm-task',
                accept: () => {
                    if (this.taskData.isEditable) {
                        this.appMainService.isShowSpinner("getTaskTimerHistory");
                        this.taskService.deleteTask(this.selectedTaskId).subscribe({
                            next: (response: any) => {
                                this.appMainService.isHideSpinner("getTaskTimerHistory");
                                this.currentDisplay = false;
                                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Task Deleted Successfully' });
                                this.onUpdateComplete.emit({});
                                this.cancelClicked.emit({});
                                this.componentCommunicationService.triggerNotesReloadList();
                            },
                            error: (error) => {
                                this.appMainService.isHideSpinner('getTaskTimerHistory');
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Error',
                                    detail: error?.error?.Message ? error?.error?.Message : 'Failed To Deleted Task'
                                });
                            }
                        })
                    } else {
                        this.messageService.add({
                            severity: 'info',
                            summary: ' Status Info',
                            detail: this.taskData.isEditableMsg
                        });
                    }
    
                },
                reject: () => { },
            });    
        }
    }

    editTask() {
        if (this.taskData.isEditable) {
            if(this.taskData.task.taskTypeId==TaskType.Subtask){
                this.editSubTask(this.task);
            }else{
                this.displayAddEditDialog = true;
            }
        } else {
            this.messageService.add({
                severity: 'info',
                summary: ' Status Info',
                detail: this.taskData.isEditableMsg
            });
        }
    }

    onCheckboxChange(checklistItem: any) {
        const checkListPayload = {
            id: checklistItem.id,
            isCheck: checklistItem.isCheck
        };
        this.appMainService.isShowSpinner("getTaskTimerHistory");
        this.taskService.markCheckedList(checkListPayload).subscribe({
            next: (response: any) => {
                this.appMainService.isHideSpinner("getTaskTimerHistory");
                this.messageService.add({ severity: 'success', summary: 'Success', detail: `Checklist item '${checklistItem.description}' is Updated` });
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getTaskTimerHistory');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To Update CheckList'
                });
            }
        })
    }
    //mini
    onMaximize() {
        this.isMini = false;
        this.onBodyHidden();
    }

    onBodyAuto() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-hidden');
        body.classList.add('overflow-auto');
    }

    onBodyHidden() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('overflow-auto');
        body.classList.add('overflow-hidden');
    }

    //handle permissions
    get showEditButton() {
        return !this.timerRunningTasks?.length && (this.app?.userId == this.taskData?.createdBy || !this.taskData?.createdBy);
    }

    get showSubTaskEditButton() {
        return !this.timerRunningTasks?.length && (this.app?.userId == this.taskData?.createdBy || this.app?.userId == this.task?.taskUsers || this.app?.userId == this.task?.reAssignedTo ||
            this.taskData?.task.childTaskDto?.some(childTask => 
                childTask.childSubTasks?.some(subtask => 
                    subtask.createdBy == this.app?.userId || subtask.taskUsers == this.app.userId || subtask.reAssignedTo == this.app.userId
                )
            )
        );
    }
   
    refreshViewData() {
        this.loadNewList();
    }

    getSanitizedDescription(description: string): SafeHtml {
        return description ? this.sanitizer.bypassSecurityTrustHtml(description) : '';
    }

    checkTimerRunningTasks() {
        const runningTasks = this.timerRunningTasks;
        this.taskService.setTimerRunningTaskData(runningTasks);
    }


    //#region AssociatonClick
    openViewPopUp(associationId) {
        const slectedAssociationId = associationId;
        switch (this.taskData?.objectTypeId) {
            case LeadModuleId:
                this.openLeadViewEdit(slectedAssociationId);
                break;
            case AccountModuleId:
                this.openAccountViewEdit(slectedAssociationId);
                break;
            case OpportunityModuleId:
                this.openOpportunityViewEdit(slectedAssociationId);
                break;
            case CaseModuleId:
                this.openCaseViewEdit(slectedAssociationId);
                break;
            default:
                break;
        }
    }

    openAccountViewEdit(accountId: number) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = accountId;
    }

    closeAccountViewEditModal() {
        this.displayAccountViewEdit = false;
        this.selectedAccountId = 0;
    }


    openLeadViewEdit(leadId: number) {
        this.displayLeadViewEdit = true;
        this.selectedLeadId = leadId;
    }

    closeLeadViewEdit() {
        this.displayLeadViewEdit = false;
        this.selectedLeadId = 0;
    }

    openOpportunityViewEdit(opportunityId: number) {
        this.displayOpportunityViewEdit = true;
        this.opportunityEditViewId = opportunityId;
    }

    closeOpportunityViewEdit() {
        this.displayOpportunityViewEdit = false;
        this.opportunityEditViewId = 0;
    }

    openCaseViewEdit(caseId: number) {
        this.displayCaseViewEdit = true;
        this.caseEditViewId = caseId;
        this.getUserGroupList();
    }

    closeCaseViewEdit() {
        this.displayCaseViewEdit = false;
        this.caseEditViewId = 0;
    }

    reloadResultAfterSave() {
        this.fetchSelectedTask(this.selectedTaskId);
    }

    getUserGroupList() {
        this.accOpportunityService.getUserGroups(this.app.user.organizationId).subscribe(
            (groupUserList) => {
                this.groupUserList = groupUserList;
            },
            err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while fetching user groups...' });
            }
        );
    }

    //#endregion AssociatonClick
    changeTaskOption(task: any){
        switch(this.selectedTaskOption.code){
            case 'comment':
                this.addComment(task);
                break;
            case 're-assign':
                this.reassign(task);
                break;
            case 'sub-task':
            this.createSubTask(task);
                break
        }

        setTimeout(() =>{
            this.selectedTaskOption = null;
        })
    }

     //#region ClickOnResign

    reassign(selectedTaskData: any) {
        this.selectedReAssignData = selectedTaskData;
        this.displayReassign = true;
    }


    initReAssignUserForm(){
        this.detailsFormErrors = {};
        this.reAssignUserForm = this.formBuilder.group({
            id:[0],
            reAssignedTo: ['', Validators.required],
            description: [null]
        })
        this.formErrorHandler.handleErrors(this.reAssignUserForm, this.detailsFormErrors,{
            reAssignedTo:{
                required: 'Re-assign User is required'
            }
        })
    }

    reassignUser() {
        const selectedList: any =  JSON.parse(JSON.stringify(this.reAssignUserForm.value.reAssignedTo));
        this.selectedReassignUser = this.reAssignUserForm.value.
        reAssignedTo ? selectedList : [];
        this.displayUsers = true;
    }

    saveReAssignUser($event) {
        const selectedUser = JSON.parse(JSON.stringify($event.selectedUsers));
        this.selectedReassignUser = [...selectedUser];
        if (this.selectedReassignUser) {
            this.reAssignUserForm.patchValue({
                reAssignedTo: this.selectedReassignUser[0]
            });
          }
        this.displayUsers = false;
    }

    assignUserPopupCancelClicked() {
        this.displayUsers = false;
    }

    cancelReAssignPopup(){
        this.displayReassign=false
        this.reAssignUserForm.reset();
    }


    saveReAssignUserData(){
        if (this.reAssignUserForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
          }
          const reAssignFromValues = this.reAssignUserForm.getRawValue();
          this.confirmationService.confirm({
            message: "Do you want to Re-Assign this Task?",
            header: "Change Confirmation",
            icon: "pi pi-info-circle",
            key: 'confirm-task',
            accept: () => {
                if (reAssignFromValues) {
                    const reAssignData : ReAssignTaskPayload ={
                        taskId: this.selectedReAssignData?.taskId,
                        description: reAssignFromValues?.description,
                        userId: reAssignFromValues.reAssignedTo?.id
                    }
                    this.appMainService.isShowSpinner("reAssignTask");
                    this.taskService.reAssignTask(reAssignData).subscribe({
                        next: (response: any) => {
                            this.appMainService.isHideSpinner("reAssignTask");
                            this.loadNewList();
                            this.displayReassign = false;
                            this.reAssignUserForm.reset();
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Task Re-Assigned Successfully' });
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner('reAssignTask');
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error?.error?.Message ? error?.error?.Message : 'Failed To Deleted Task'
                            });
                        }
                    })
                }

            },
            reject: () => { },
        });

    }



    //#endregion ClickOnResign

    editSubTask(taskDetails: any){
        if (taskDetails.isCompleted) {
            this.messageService.add({
                severity: 'info',
                summary: ' Status Info',
                detail: "Sub-Task is Completed"
            });
            return;
        }
        this.selectedTaskDataForSubTask = taskDetails;
        this.editedSubtaskDetails = taskDetails;
        this.displaySubTask = true;
    }

    createSubTask(selectedTask:any){
        this.editedSubtaskDetails = null;
        this.displaySubTask = true;
        this.selectedTaskDataForSubTask = selectedTask;
    }

    toogleTimelineActivity(stageDetails: any){
        stageDetails['expanded'] = !stageDetails?.expanded;
    }

    closeSubTaskPopup(){
        this.displaySubTask = false;
    }

    deleteSubTask(taskDetails:any, returnFromdeleteTask?:boolean) {
        if (taskDetails.isCompleted) {
            this.messageService.add({
                severity: 'info',
                summary: ' Status Info',
                detail: "Sub-Task is Completed"
            });
            return;
        }

        this.confirmationService.confirm({
            message: "Do you want to Delete this Sub Task?",
            header: "Change Confirmation",
            icon: "pi pi-info-circle",
            key: 'confirm-task',
            accept: () => {
                if (this.taskData.isEditable) {
                    this.appMainService.isShowSpinner("getTaskTimerHistory");
                    this.taskService.deleteSubTask(taskDetails?.taskId).subscribe({
                        next: (response: any) => {
                            this.appMainService.isHideSpinner("getTaskTimerHistory");
                            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Sub Task Deleted Successfully' });                          
                            if(!returnFromdeleteTask){
                                this.loadNewList();
                            }
                            else{
                                this.currentDisplay = false;
                                this.onUpdateComplete.emit({});
                                this.cancelClicked.emit({});
                            }
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner('getTaskTimerHistory');
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: error?.error?.Message ? error?.error?.Message : 'Failed To Deleted Sub Task'
                            });
                        }
                    })
                } else {
                    this.messageService.add({
                        severity: 'info',
                        summary: ' Status Info',
                        detail: this.taskData.isEditableMsg
                    });
                }

            },
            reject: () => { },
        });
    }

    showCheckbox(): boolean {
        return this.app.userId === this.taskData?.createdBy || this.task?.isSharedUser;
    }

    isCheckboxDisabled(): boolean {
        // Only check moduleRestrictNotifyStatusSharedUser if the user is a shared user
        if (this.task?.isSharedUser) {
            return this.taskData?.moduleRestrictNotifyStatusSharedUser;
        }
        return false; // Not disabled for creator
      }

      onNotificationCheckboxChange(event: any): void {
        const isSwitchChecked = event.checked;
        this.confirmationService.confirm({
          message: isSwitchChecked
            ? "Do you want to enable notification and email restrictions?"
            : "Do you want to disable notification and email restrictions?",
          header: "Confirmation",
          icon: "pi pi-info-circle",
          key: 'confirm-task',
          accept: () => {
            this.handleNotificationEmailToggle(isSwitchChecked);
          },
          reject: () => { 
            this.notificatonEmailCheckbox = !isSwitchChecked;
          },
         
        });
      }
      
       handleNotificationEmailToggle(isEnable: boolean): void {
        this.appMainService.isShowSpinner('setDefaultValues');
        const data = { taskId: this.taskData?.tsId };
        const apiCall = isEnable 
          ? this.sharedTaskService.setNotificationEmailSettings(data) 
          : this.sharedTaskService.deleteNotificationEmailFromTaskDetails(this.taskData?.tsId);
      
        apiCall.subscribe({
          next: () => {
            this.loadNewList();
            this.onToggleSuccess(isEnable);
          },
          error: (error) => {
            this.onToggleError(error);
          }
        });
      }
      
       onToggleSuccess(isEnable: boolean): void {
        const successMessage = isEnable
          ? 'Notification and email restrictions enabled successfully'
          : 'Notification and email restrictions disabled successfully';
      
        this.appMainService.isHideSpinner('setDefaultValues');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: successMessage
        });
      }
      
       onToggleError(error: any): void {
        this.appMainService.isHideSpinner('setDefaultValues');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.Message ?? 'Something went wrong'
        });
      }

      setInitialCheckboxState() {
        if (this.taskData) {
          if (this.app.userId === this.taskData.createdBy) {
            // For creator
            this.notificatonEmailCheckbox = this.taskData.taskRestrictNotifyStatusCreatedUser;
          } else if (this.task?.isSharedUser) {
            this.notificatonEmailCheckbox = this.taskData?.moduleRestrictNotifyStatusSharedUser ? this.taskData?.moduleRestrictNotifyStatusSharedUser : this.taskData.taskRestrictNotifyStatusSharedUser;
          }
        }
      }

    sendReminderToAssignees(slectedTaskDetails:any){
        const taskUserName = slectedTaskDetails.reAssignedStatus ? slectedTaskDetails.reAssignedToName : slectedTaskDetails.taskUsersName;
        this.confirmationService.confirm({
          message: `You are about to send a reminder to <b>${taskUserName}</b> for this task. Do you want to proceed?`,
          header: "Send Task Reminder",
          icon: "pi pi-bell",
          key: 'confirm-task',
          acceptLabel: 'Yes, Send Reminder',
          rejectLabel: 'Cancel',
          accept: () => {
            this.appMainService.isShowSpinner("sendReminder");
            const data = { taskId: slectedTaskDetails.taskId };
            this.sharedTaskService.sendReminderToAssignee(data).subscribe({
                next: (response: any) => {
                    this.appMainService.isHideSpinner("sendReminder");
                    this.loadNewList();
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reminder sent successfully' });
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('sendReminder');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.Message ? error?.error?.Message : 'Failed to send reminder. Please try again'
                    });
                }
            })
          },
          reject: () => { 

          },
         
         
        });
        
    }

    loadMoreComments(stageDetails: any) {
        const loadStep = this.defaultPanelData;
        if (!stageDetails.visibleCount) {
          stageDetails.visibleCount = loadStep;
        }
        const nextCount = stageDetails.visibleCount + loadStep;
        stageDetails.visibleCount = Math.min(nextCount, stageDetails.commentList.length);
      } 
      
    ngOnDestroy(): void {
        this.taskService.clearTimerRunningTaskData();
    }

}


